/* eslint-disable */

import * as clientService from "../services/httpsClient";

export const getCustomerBill = async (accessToken, params) => {
  try {
    return await clientService.getApi(`customerbill`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getCustomerBillById = async (accessToken, id) => {
  try {
    const domain = `customerbill/${id}`;
    // const domain = `customerbill/export-bill/${id}`;
    return await clientService.getApi(domain, accessToken);
  } catch (error) {
    throw error;
  }
};

export const deleteCustomerBill = async (accessToken, body) => {
  try {
    const domain = `customerbill`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createCustomerBill = async (accessToken, body) => {
  try {
    const domain = `customerbill/issue-bill`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCustomerBill = async (accessToken, body) => {
  try {
    const domain = `customerbill`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCustomerBillItem = async (accessToken, params) => {
  const { page, limit, customer_bill_no } = params;
  let object = {
    page: page ? page : 0,
    limit: limit ? limit : 10,
    customer_bill_no: customer_bill_no ? customer_bill_no : undefined,
  };

  try {
    return await clientService.getApi(`customerbill/items`, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const updateCustomerBillItem = async (accessToken, body) => {
  try {
    const domain = `customerbill/items`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCustomerBillImage = async (accessToken, params) => {
  const { customer_bill_no } = params;
  try {
    return await clientService.getApi(`customerbillimage/${customer_bill_no}`, accessToken);
  } catch (error) {
    throw error;
  }
};

export const getCompanyBillImageList = async (accessToken, params) => {
  try {
    return await clientService.getApi(`customerbillimage`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const deleteCustomerBillImage = async (accessToken, body) => {
  try {
    return await clientService.deleteApi(`customerbillimage`, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createCustomerBillImage = async (accessToken, body) => {
  try {
    const domain = `customerbillimage`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getSaleList = async (accessToken) => {
  try {
    const domain = `customerbill/sales`;
    return await clientService.getApi(domain, accessToken);
  } catch (error) {
    throw error;
  }
};

export const getCustomerBillInvoice = async (accessToken, ids) => {
  try {
    const domain = `customerbill/invoice`;
    return await clientService.postApi(domain, accessToken, { ids });
  } catch (error) {
    throw error;
  }
};

export const exportCustomerBill = async (accessToken, params) => {
  const { ids } = params;
  let body = {
    ids: ids,
  };
  try {
    const domain = `customerbill/export-excel-bill`;
    return await clientService.exportExcelPost(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const exportCustomerBillAll = async (accessToken, searchParams) => {
  try {
    const domain = `customerbill/export-excel-bill-all`;
    return await clientService.exportExcelPost(domain, accessToken, searchParams);
  } catch (error) {
    throw error;
  }
};

export const exportCustomerBillInvoice = async (accessToken, ids) => {
  try {
    const domain = `customerbill/export-excel-invoice`;
    return await clientService.exportExcelPost(domain, accessToken, { ids });
  } catch (error) {
    throw error;
  }
};

export const exportCustomerBillInvoiceAll = async (accessToken, searchParams) => {
  try {
    const domain = `customerbill/export-excel-invoice-all`;
    return await clientService.exportExcelPost(domain, accessToken, searchParams);
  } catch (error) {
    throw error;
  }
};

export const exportReportSummaryCustomerBill = async (accessToken, ids) => {
  try {
    const domain = `customerbill/export-report-summary-bill`;
    return await clientService.exportExcelPost(domain, accessToken, { ids });
  } catch (error) {
    throw error;
  }
};

export const exportReportSummaryCustomerBillAll = async (accessToken, searchParams) => {
  try {
    const domain = `customerbill/export-report-summary-bill-all`;
    return await clientService.exportExcelPost(domain, accessToken, searchParams);
  } catch (error) {
    throw error;
  }
};

export const updateCustomerBillStatus = async (accessToken, body) => {
  try {
    const domain = `customerbill/update-bill-status`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
